import { ReactNode } from "react";

type ColorVariant = "orange" | "blue" | "purple" | "green" | "red" | "yellow" | "indigo" | "pink";

interface FormSectionProps {
  number: number;
  title: string;
  color?: ColorVariant;
  children: ReactNode;
}

const colorClasses: Record<ColorVariant, { bg: string; text: string }> = {
  orange: {
    bg: "bg-orange-100 dark:bg-orange-900",
    text: "text-orange-600 dark:text-orange-300",
  },
  blue: {
    bg: "bg-blue-100 dark:bg-blue-900",
    text: "text-blue-600 dark:text-blue-300",
  },
  purple: {
    bg: "bg-purple-100 dark:bg-purple-900",
    text: "text-purple-600 dark:text-purple-300",
  },
  green: {
    bg: "bg-green-100 dark:bg-green-900",
    text: "text-green-600 dark:text-green-300",
  },
  red: {
    bg: "bg-red-100 dark:bg-red-900",
    text: "text-red-600 dark:text-red-300",
  },
  yellow: {
    bg: "bg-yellow-100 dark:bg-yellow-900",
    text: "text-yellow-600 dark:text-yellow-300",
  },
  indigo: {
    bg: "bg-indigo-100 dark:bg-indigo-900",
    text: "text-indigo-600 dark:text-indigo-300",
  },
  pink: {
    bg: "bg-pink-100 dark:bg-pink-900",
    text: "text-pink-600 dark:text-pink-300",
  },
};

export const FormSection = ({ number, title, color = "blue", children }: FormSectionProps) => {
  const colorClass = colorClasses[color];

  return (
    <div className="rounded-lg border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-700 dark:bg-gray-800">
      <div className="mb-4 flex items-center gap-3">
        <div className={`flex h-8 w-8 items-center justify-center rounded-full ${colorClass.bg}`}>
          <span className={`text-sm font-semibold ${colorClass.text}`}>{number}</span>
        </div>
        <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100">{title}</h3>
      </div>
      {children}
    </div>
  );
};
